import type {
  DialogMessageOptions,
  OpenOKDialogOptionsParameter,
} from '@pct-ng/feature-message-material';
import type { StrictOmit } from '@pct-ts/typing';

export function messageDialogOptionsGenerator(i18nPrefix: string): OpenOKDialogOptionsParameter {
  return {
    title: `${i18nPrefix}.TITLE`,
    message: `${i18nPrefix}.MESSAGE`,
  } satisfies StrictOmit<DialogMessageOptions, 'type' | 'buttons'>;
}
